var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9912 6.0096L5.39919 10.5626L9.59419 12.9906L13.2932 9.2906C13.4808 9.10309 13.7353 8.99781 14.0005 8.9979C14.2658 8.99799 14.5202 9.10346 14.7077 9.2911C14.8952 9.47874 15.0005 9.73319 15.0004 9.99846C15.0003 10.2637 14.8948 10.5181 14.7072 10.7056L11.0072 14.4056L13.4372 18.5996L17.9912 6.0096ZM18.3142 3.7656C19.5092 3.3326 20.6672 4.4906 20.2342 5.6856L14.9522 20.2906C14.5182 21.4886 12.8822 21.6346 12.2432 20.5316L9.02619 14.9736L3.46819 11.7566C2.36519 11.1176 2.51119 9.4816 3.70919 9.0476L18.3142 3.7656Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGrayIcon);
export default __webpack_public_path__ + "static/media/share-gray-icon.6d9030767271a9a6a3ee72e9b9cf125f.svg";
export { ForwardRef as ReactComponent };